import t from "@/lang/lang";
import { EditorVariable } from "@/shared/components/editor/editor-variables";
import {
  baseDataTextVariables,
  offerTextVariables,
} from "@/services/backend/omni/offer/types/offer-text-variables";
import { Contract } from "./contract";

/**
 * Mirrors `offerReferenceVariables` and "$special_agreements" of
 * `newContractData`, backend/core/omni/adapters/driving/gotenbergpdf/contract.go.
 */
const contractOwnTextVariables: EditorVariable[] = [
  {
    name: "$offer_number",
    label: t("Angebotsnummer"),
    description: t("Nummer des zugrunde liegenden Angebots"),
  },
  {
    name: "$offer_date",
    label: t("Angebotsdatum"),
    description: t("Datum des zugrunde liegenden Angebots"),
  },
  {
    name: "$special_agreements",
    label: t("Besondere Vereinbarungen"),
    description: t("Die Sonderabsprachen des Vertrags"),
  },
];

/**
 * contractTextVariables returns the variables the text of the contract
 * may use: those of an offer, see {@link offerTextVariables}, the
 * number and date of the referenced offer and its special agreements.
 */
export function contractTextVariables(
  contract: Pick<Contract, "scopeOfWork" | "serviceKind">,
): EditorVariable[] {
  return [...offerTextVariables(contract), ...contractOwnTextVariables];
}

/**
 * contractBaseDataTextVariables returns the variables a text of the
 * contract base data of the service kind may use, see
 * {@link baseDataTextVariables}, the number and date of the referenced
 * offer and the special agreements of the contract.
 */
export function contractBaseDataTextVariables(
  serviceKind: string,
): EditorVariable[] {
  return [...baseDataTextVariables(serviceKind), ...contractOwnTextVariables];
}
